import { Component } from '@angular/core';
import { observeParam } from '@suvo/frontend-framework/standalone/router/params';

@Component({
  standalone: false,
  selector: 'app-item-view-screen',
  template: `
    <app-customer-header [showBreadcrumbBackButton]="true" [disableFirstBreadcrumbLink]="true" />

    <suvo-bi-data-source-item-view [alias]="alias | async" [itemId]="itemId | async" />
  `,
})
export class ItemViewScreenComponent {
  readonly alias = observeParam('route', 'alias');
  readonly itemId = observeParam('route', 'itemId');
}
